import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const SubdomainTutorial = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">Quick Tutorial: Creating Subdomains in cPanel for Your Website</h1>
          <span className="small ms-2"><b>Publish By:-</b> CodeInputs</span>
          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/subdomain.webp" fluid alt="Subdomain Setup" />
            </Col>
          </Row>
          <p className="mt-4 blacktext">
            Setting up subdomains can help you create separate sections of your website, such as a blog or shop, all within the same domain. In this quick tutorial, we’ll walk you through the steps to create subdomains in cPanel, from accessing your cPanel dashboard to configuring and managing your subdomain. Perfect for beginners and website owners looking to expand their online presence with ease.
          </p>
          <h4>What is a Subdomain?</h4>
          <p className="mt-4 blacktext">
            A subdomain is an additional part of your main domain name that acts as a separate, customizable section of your website. It appears before the main domain in a web address, separated by a dot. For example, in blog.example.com, "blog" is the subdomain, and example.com is the main domain.</p>

            <p className="mt-4 blacktext">Subdomains are useful for organizing and expanding a website by creating different areas, such as a blog (blog.example.com), a shop (shop.example.com), or a support page (support.example.com). Each subdomain functions as its own unique section while still being connected to the main domain. This is often used to keep different types of content organized and accessible for users.</p>
          <Row className="mt-3">
            <Col md={12}>
              <Image src="/graphics/images/subdomain1.webp" fluid alt="Subdomain Example" />
            </Col>
          </Row><br />
          <h4>Step-by-Step Guide</h4>
          <h5 className="mt-4 orgspan fw-bold">Step 1: Log in to Your cPanel Account</h5>
          <ol>
              <li className="blacktext fw-normal mb-3">Access your cPanel by entering yourdomain.com/cpanel in your browser.</li>

              <li className="blacktext fw-normal mb-3">Enter your cPanel username and password.</li>
          </ol>
          <h5 className="mt-4 orgspan fw-bold">Step 2: Find the Subdomains Option</h5>
          <ol>
                  <li className="blacktext fw-normal mb-3">In the <b>Domains</b> section, click on <b>Domains</b> or <b>Addon Domains</b> depending on your cPanel version.</li>

                  <img className="img-responsive" src="/images/domain_section.webp" width="100%" alt="domain section"/>

                  <li className="blacktext fw-normal mb-3">If you’re adding a new subdomain click <b>Create a New Domain</b> button.</li>

                  <img className="img-responsive" src="/images/create_domain.webp" width="100%" alt="backup"/>

                  <li className="blacktext fw-normal">Fill in the <b>New Domain Name</b> field with the subdomain you want to add.</li>

                  <img className="img-responsive" src="/images/domain_form.webp" width="100%" alt="backup"/>

                  <li className="blacktext fw-normal">After entering the subdomain name, the <b>domain</b> and <b>Document Root</b> fields will populate automatically. Adjust these if needed.</li>

                  <li className="blacktext fw-normal">Click <b>Add Domain</b> to save the subdomain.</li>
                </ol>
          <h5 className="mt-4 orgspan fw-bold">Step 3: Configure Subdomain Settings</h5>
          <ol>
                  <li className="blacktext fw-normal">Once the Subdomain is added, configure any settings specific to this Subdomain, such as email accounts, SSL certificates, or redirects.</li>

                  <img className="img-responsive" src="/images/manage_setting.webp" width="100%" alt="manage setting" />
          </ol>
          <p className="mt-4 blacktext">Now your new Subdomain should be added and ready for use within cPanel!</p>
          <Row className="mt-3">
            <Col md={12}>
              <Image src="/images/list_domain.webp" fluid alt="List of Domains" />
            </Col>
          </Row>
          <iframe
            className="mt-4"
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/byXEOPqkwgI"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Col>
        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Post</h4>
            <RecentPost/>
          </Card>
          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p style={{ color: '#85929e' }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default SubdomainTutorial;